import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".portfolio-list",
    start: "top center",

  },
});

tl.fromTo(
  ".portfolio-list__item",
  {
    opacity: 0,
    scale: 0,
  },
  {
    stagger: {
      each: 0.1,
      from: [0, 0],
      grid: "auto",
    },
    opacity: 1,
    scale: 1,
  }
);
const tl2 = gsap.timeline({
  scrollTrigger: {
    trigger: ".conference-wrapper",
    start: "top center",

  },
});

tl2.fromTo(
  ".conference__item",
  {
    opacity: 0,
    scale: 0,
  },
  {
    stagger: {
      each: 0.1,
      from: [0, 0],
      grid: "auto",
    },
    opacity: 1,
    scale: 1,
  }
);
